query MfaLabelOptions($limit: Int = 1000) {
	mfa_session_runs(limit: $limit, sort: { fields: run_time, order: Descending }) {
		custom_fields
		app
		app_version
	}
}
